import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import "./ServiceHomePage.css";

// Images
import appSoftwareImg from "../../Asstets/AppSoftware.png";
import contentWritingImg from "../../Asstets/Content Writing.png";
import influencerMarketingImg from "../../Asstets/Influencer Marketing.png";
import onlineBrandingImg from "../../Asstets/Online Branding.png";
import performanceMarketingImg from "../../Asstets/performanceMarketing.png";
import productShootImg from "../../Asstets/productShootImg.png";
import seoImg from "../../Asstets/seoImg.png";
import socialMediaImg from "../../Asstets/socialMediaImg.png";
import videoEditingImg from "../../Asstets/videoEditing.png";

const DOMAIN = "https://skylinebussiness.com"; // ✅ CHANGE IF NEEDED

const services = [
  { title: "App Software", category: "Development", image: appSoftwareImg, path: "/app-software" },
  { title: "Content Writing", category: "Marketing", image: contentWritingImg, path: "/content-writing" },
  { title: "Influencer Marketing", category: "Social Growth", image: influencerMarketingImg, path: "/influencer-marketing" },
  { title: "Online Branding", category: "Branding", image: onlineBrandingImg, path: "/online-branding" },
  { title: "Performance Marketing", category: "Ads & ROI", image: performanceMarketingImg, path: "/performance-marketing" },
  { title: "Product Photography", category: "Photography", image: productShootImg, path: "/product-photography" },
  { title: "SEO Services", category: "Search Engine", image: seoImg, path: "/seo-services" },
  { title: "Social Media Management", category: "Engagement", image: socialMediaImg, path: "/social-media-management" },
  { title: "Video Editing", category: "Production", image: videoEditingImg, path: "/video-editing" },
];

const ServiceHomePage = () => {
  const navigate = useNavigate();

  return (
    <main className="services-container">

      {/* ✅ SEO META */}
      <Helmet>
        <title>Our Services | Skyline Bussiness Solutions</title>

        <meta
          name="description"
          content="Explore professional digital services including SEO, app development, social media management, influencer marketing, and more by Skyline Bussiness Solutions."
        />

        {/* ✅ Canonical URL */}
        <link rel="canonical" href={`${DOMAIN}/services`} />

        {/* ✅ Open Graph (for social sharing) */}
        <meta property="og:title" content="Our Services | Skyline Bussiness Solutions" />
        <meta
          property="og:description"
          content="High-quality digital services to grow your business faster — SEO, development, marketing & more."
        />
        <meta property="og:url" content={`${DOMAIN}/services`} />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* TITLE */}
      <motion.h1
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Our Services
      </motion.h1>

      {/* SUBTEXT */}
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        Skyline Bussiness Solutions provides high-quality digital services
        to help your business grow faster and smarter.
      </motion.p>

      {/* GRID */}
      <motion.div
        className="services-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
          visible: {
            transition: { staggerChildren: 0.15 }
          }
        }}
      >
        {services.map((service, index) => (
          <motion.div
            className="service-card"
            key={index}
            onClick={() => navigate(service.path)}
            role="button"
            tabIndex={0}

            variants={{
              hidden: { opacity: 0, y: 40, scale: 0.95 },
              visible: { opacity: 1, y: 0, scale: 1 }
            }}
            transition={{ duration: 0.4 }}
          >
            {/* ✅ IMAGE SEO */}
            <img
              src={service.image}
              alt={`${service.title} services by Skyline Bussiness Solutions`}
              loading="lazy"
            />

            <div className="service-info">
              <h3>{service.title}</h3>
              <p>{service.category}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

    </main>
  );
};

export default ServiceHomePage;